import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { FileType, StockHoldingFileType } from "operations/schema/schema";
import { State } from "./files.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

function uint8ToBase64(u8Arr: Uint8Array): string {
  const CHUNK_SIZE = 0x8000; 
  let result = "";
  for (let i = 0; i < u8Arr.length; i += CHUNK_SIZE) {
    const chunk = u8Arr.subarray(i, i + CHUNK_SIZE);
    result += String.fromCharCode(...chunk);
  }
  return btoa(result);
}

export const asyncQueries = {
  getStockHoldingFiles: createAppAsyncThunk(
    "files/getStockHoldingFiles",
    async (
      { stockHoldingId }: { stockHoldingId: string },
      { rejectWithValue, extra: { sdk } }
    ) => {
      const { data, errors } = await graphqlRequest(sdk.getStockHoldingFiles, {
        variables: { stockHoldingId },
      });

      if (errors) return rejectWithValue(errors);
      if (!data?.stockHoldingFiles) return rejectWithValue("something went wrong");

      const convertedFiles: FileType[] = data.stockHoldingFiles.map(
        (f: StockHoldingFileType) => {
          const byteArray = new Uint8Array(f.data);
          const fileData = uint8ToBase64(byteArray);
          return {
            id: f.id,
            name: f.name,
            description: f.description ?? "",
            data: fileData,
            size: byteArray.length,
            isFullSize: false,
          };
        }
      );

      return convertedFiles;
    }
  ),
};

export const queryBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncQueries.getStockHoldingFiles.pending, (state) => {
    state.loadingFiles = true;
    return state;
  });

  builder.addCase(asyncQueries.getStockHoldingFiles.rejected, (state) => {
    state.loadingFiles = false;
    return state;
  });

  builder.addCase(
    asyncQueries.getStockHoldingFiles.fulfilled,
    (state, { payload }) => {
      state.loadingFiles = false;
      state.files = [...state.files, ...payload];
      return state;
    }
  );
};